(function($) {
  $('.search__form--ask-une').submit(function(event) {
    event.preventDefault();

    var keywords = encodeURIComponent(
      $(this)
        .find('.search__input-field')
        .val()
    );

    var searchUrl =
      $(this)
        .find('.search__dropdown-field')
        .val() + keywords;

    window.location = searchUrl;
    return false;
  });
}(jQuery));
